import api, { ApiResponse } from './api';

export interface NotificationSettings {
  is_enabled: boolean;
  bot_token: string | null;
  schedule_enabled: boolean;
  schedule_chat_id: string | null;
  panel_enabled: boolean;
  panel_chat_id: string | null;
}

export interface UpdateNotificationSettingsRequest {
  is_enabled?: boolean;
  bot_token?: string;
  schedule_enabled?: boolean;
  schedule_chat_id?: string;
  panel_enabled?: boolean;
  panel_chat_id?: string;
}

export const notificationsService = {
  async getSettings(): Promise<NotificationSettings> {
    const response = await api.get<ApiResponse<NotificationSettings>>('/notifications/settings');
    return response.data.data;
  },

  async updateSettings(data: UpdateNotificationSettingsRequest): Promise<NotificationSettings> {
    const response = await api.put<ApiResponse<NotificationSettings>>('/notifications/settings', data);
    return response.data.data;
  },

  async test(type: 'schedule' | 'panel' = 'schedule'): Promise<{ message: string }> {
    const response = await api.post<ApiResponse<null> & { message: string }>('/notifications/test', { type });
    return { message: response.data.message || 'Test sent' };
  },
};
